import axios from 'axios'

export default {
  fetchAll () {
    return axios.get('/a/settings/homepage_banners/reorder.json')
      .catch((err) => { window.alert(err) })
  },
  sort (sortOrders) {
    return axios.post('/a/settings/homepage_banners/sort_banners', { sort_orders: sortOrders })
      .catch((err) => { window.alert(err) })
  }
}
